import { render, staticRenderFns } from "./vehicleTypeView.vue?vue&type=template&id=3351e5c2&scoped=true&"
import script from "./vehicleTypeView.vue?vue&type=script&lang=js&"
export * from "./vehicleTypeView.vue?vue&type=script&lang=js&"
import style0 from "./vehicleTypeView.vue?vue&type=style&index=0&id=3351e5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351e5c2",
  null
  
)

component.options.__file = "vehicleTypeView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDataTable,
  VFlex,
  VProgressCircular,
})
